import { Injectable } from '@angular/core';

@Injectable()
export class MenuService {

    menuItems: Array<any>;

    constructor() {
        this.menuItems = [];
    }

    addMenu(items: Array<{
        name: string,
        link?: string,
        href?: string,
        imgpath?: string,
        order?: number,
        iconclass?: string,
        role_required?: string,
        label?: any,
        subitems?: Array<any>
    }>) {
        items.forEach((item) => {
            this.menuItems.push(item);
        });
    }

    getMenu() {
        return this.menuItems;
    }

    getMenuSorted() {
        return this.menuItems.sort((a, b) => a.order - b.order);
    }

}



// WEBPACK FOOTER //
// ./src/app/core/menu/menu.service.ts